/* istanbul ignore file */
import React, { ReactElement, useEffect, useRef } from "react";
import "./inhoudsopgave.scss";
import Heading from "../components/Heading";
import { Chapter } from "../components/Chapter";

export const InhoudsopgaveChapter = (): ReactElement => {
  const tocRef = useRef<HTMLDivElement>(null);
  const content = document.getElementById("rapportage-onderdelen");

  const createTableOfContents = (): void => {
    if (!content) {
      return;
    }

    const tocElement = tocRef.current;

    if (!tocElement) {
      return;
    }

    const tocUl = document.createElement("div");
    tocUl.id = "list-toc-generated";
    tocUl.className = "toc-list";

    // Find all h1 and h2 elements in the content
    const headers = Array.from(
      content.querySelectorAll("h1, h2")
    ) as HTMLElement[];

    headers.forEach((header, index) => {
      if (header.textContent === "") {
        return;
      }

      if (header.dataset.ignoreToc === "true") {
        return;
      }

      if (!header.id) {
        header.id = `toc-header-${index}`;
      }

      const div = document.createElement("div");
      div.classList.add("toc-item");
      if (header.tagName === "H2") {
        div.classList.add("toc-item-h2");
      }

      // Create the anchor element that will make the title clickable
      const anchorLink = document.createElement("a");
      anchorLink.classList.add("toc-item-link");
      anchorLink.href = `#${header.id}`;

      // Create the span for the title text
      const titleSpan = document.createElement("span");
      titleSpan.textContent = header.textContent;
      titleSpan.classList.add("toc-item-title");

      // Append the title span to the anchor link, making the title clickable
      anchorLink.appendChild(titleSpan);

      // Create the span for the page number (remains separate)
      const pagenumber = document.createElement("div");
      pagenumber.className = "toc-item-pagenumber";
      // Using a slightly more descriptive ID for the page number placeholder
      pagenumber.id = `toc-pagenum-${header.id}`;

      // Append the clickable title (anchorLink) and the pagenumberSpan to the div
      div.appendChild(anchorLink);
      div.appendChild(pagenumber);
      tocUl.appendChild(div);
    });

    tocElement.appendChild(tocUl);
  };

  useEffect(() => {
    createTableOfContents();
  });

  return (
    <Chapter>
      <Heading text="Inhoudsopgave" ignoreTOC={true}></Heading>

      <div id="inhoudsopgave" className="inhoudsopgave">
        <div id="inhoudsopgave" ref={tocRef}></div>
      </div>
    </Chapter>
  );
};
